import React, { useEffect, useState } from 'react'
import {
  Spin, FloatButton, Flex,
} from 'antd'
import { ThemeProvider } from 'styled-components'

import { PortalFooter, CompanyInfo, VacanciesListWithFilter } from 'components/organisms'
import { SettingsService } from 'domain/settings'
import { VacanciesService } from 'domain/vacancies'
import { theme } from 'common/theme'
import { ISettings } from 'domain/settings/settings.types'
import { IVacancy } from 'domain/vacancies/vacancies.types'

export const VacancyPortal = () => {
  const [settings, setSettings] = useState<ISettings>(null)
  const [vacancies, setVacancies] = useState<IVacancy[]>(null)

  useEffect(() => {
    const companyCode = window.location.pathname.replace('/', '')

    SettingsService.getSettings(companyCode).then((data) => data && setSettings(data))
    VacanciesService.getVacancies(companyCode).then((data) => data && setVacancies(data))
  }, [])

  const isLoaded = settings && vacancies

  const colorPrimary = (settings && settings.color) || theme.token.colorPrimary

  if (!isLoaded) {
    return (
      <Flex
        align="center"
        vertical
      >
        <Spin
          data-testid="vacancy-portal-spinner"
          size="large"
          spinning={!isLoaded}
          style={{ marginTop: 100 }}
        />
      </Flex>
    )
  }

  return (
    <ThemeProvider theme={{ colorPrimary }}>
      <Flex
        align="center"
        style={{ minHeight: '100vh' }}
        vertical
      >
        <Flex
          gap={10}
          style={{ width: '100%', maxWidth: 414, padding: 16 }}
          vertical
        >
          {settings && <CompanyInfo settings={settings} />}
          {vacancies && (
          <VacanciesListWithFilter
            companyButtonLabel={settings.settings?.buttonLabel}
            vacancies={vacancies}
          />
          )}
        </Flex>
        {isLoaded && <PortalFooter />}
      </Flex>
      <FloatButton.BackTop />
    </ThemeProvider>
  )
}
